import {
    type GetUploadTokenForAnnouncementCoverResponseType,
    type GetUploadTokenForAnnouncementCoverRequestType
} from "./type";
import {
    request
} from "../request";

const GetUploadTokenForAnnouncementCover = async (params: GetUploadTokenForAnnouncementCoverRequestType): Promise<GetUploadTokenForAnnouncementCoverResponseType> => {
    return await request<GetUploadTokenForAnnouncementCoverResponseType>("/announcement/getUploadTokenForAnnouncementCover", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetUploadTokenForAnnouncementCover;
